import CommentsTable from './CommentsTable';

export default CommentsTable;
